import React, { FC } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import  Datepicker  from "../../generic/Datepicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import { onAddLeaveType, onUpdateLeaveType } from "../../../services/leave";

export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const departmentPickhook = usePickerhook();
  const { selectedOrgDepts } = useDepartmentHook();
  const { setLoading } = useStateSetter();
  const { AddEmployee } = useEmployeeHook();

  const watchedFields = watch(["title", "description"]);
  const { SelectedOrg, config } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );
  const onSubmit = async (data: any) => {
    console.log(data);

    var postdata = {
      leaveName: data.title, //Required - STRING
      description: data.description, // Optional - STRING
     // maxDaysAllowed: 30, //Required - INTERGER
     // carryForward: true, //Required - BOOLEAN
//paidLeave: true, //Required - BOOLEAN
      //: SelectedOrg.id, // Required - INTEGER
    };
    setLoading(true);
try{
 var res =  await  onUpdateLeaveType( props.item.id,postdata, config);
toast(res.message)
}

catch(e:any){
  console.log(e)
  toast.error(e)
}

finally{
  props.refresh()

  setLoading(false)
}


    props.show(false);

    setLoading(false);
    props.refresh();
  };
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">Edit Leave Type</p>
          <div className="   	 ">
            <InputField
              name="title"
              title="Leave Title"
              placeholder={"title"}
              defaultvalue={props.item?.leaveName}
              control={control}
              rules={{
                required: "title is required",
                pattern: {
                  value: textReg,
                  message: "Invalid title",
                },
              }}
            />

            <InputField
              name="description"
              title="Description"
              placeholder={"description"}
              control={control}

              defaultvalue={props.item?.description}

              isTextArea
              rules={{
                required: "description is required",
                pattern: {
                  value: textReg,
                  message: "Invalid description",
                },
              }}
            />
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Update Leave Type"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
